<div class="express-auto-details-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'"
     [class.page-loaded]="isPageLoaded"
     [style.background-color]="getPageHeaderSectionBackgroundColor()">
  <!-- Page Header Section (contains header inside) -->
  <section 
    class="page-header-section website-element express-details-page-header-element" 
    *ngIf="isSectionVisible('page-title')"
    [class.selected]="getPageHeaderSectionElement()?.selected"
    (click)="onPageHeaderSectionClick($event)">
    
    <!-- Header Section inside Page Header Section -->
    <div class="page-header-header-wrapper" (click)="onHeaderClick($event)">
      <div class="website-element header-element" 
           *ngIf="isSectionVisible('header')"
           [class.selected]="getHeaderElement()?.selected">
        <app-champs-page-header
          [logo]="getHeaderLogo()"
          [navigation]="getHeaderNavigation()"
          [ctaButton]="getHeaderCTAButton()"
          [visible]="true"
          [clickable]="true"
          [selected]="getHeaderElement()?.selected || false"
          [headingColor]="headingColor"
          [headingFont]="headingFont"
          [backgroundColor]="getHeaderBackgroundColor()"
          [deviceType]="deviceType"
          (navigationClick)="onNavigationClick($event)">
        </app-champs-page-header>
      </div>
    </div>

    <!-- Page Header Content -->
    <div class="page-header-content-wrapper">
      <div class="page-header-container">
        <h1 class="section-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles()">{{ getPageTitle() }}</h1>
        <p class="section-subtitle"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getPageSubtitle() }}</p>
      </div>
    </div>
  </section>

  <!-- Services Section -->
  <section 
    class="services-section website-element" 
    *ngIf="isSectionVisible('services_section') && !loading && !error">
    <div class="services-container">
      <div class="services-grid">
        <div class="service-card" *ngFor="let package of packages; trackBy: trackById">
          <!-- Service Image -->
          <div class="service-image">
            <img [src]="getPackageImage(package)" 
                 [alt]="package.package_name"
                 [style.object-fit]="getPackageImageFit(package)"
                 (error)="onImageError($event)">
          </div>

          <!-- Service Content -->
          <div class="service-content">
            <!-- Service Title -->
            <h3 class="service-title"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()">{{ package.package_name }}</h3>

            <!-- Pricing -->
            <div class="service-pricing">
              <div class="price-small" *ngIf="formatPrice(getStrikeoffPrice(package)) !== '$0.00'">{{ formatPrice(getStrikeoffPrice(package)) }}</div>
              <div class="price-large">{{ formatPrice(getListPrice(package)) }}</div>
            </div>

            <!-- Features List -->
            <div class="features-section">
              <ul class="features-list">
                <li class="feature-item" *ngFor="let feature of package.features; trackBy: trackByIndex">
                  <span class="feature-icon">●</span>
                  <span class="feature-text">{{ feature }}</span>
                </li>
              </ul>
            </div>

            <!-- Availability -->
            <div class="availability" *ngIf="package.locations && package.locations.length > 0">
              Available at {{ package.locations.length === 1 ? 'select location' : 'all locations' }}
            </div>

            <!-- Book Button -->
            <button class="book-button"
                    [style.background-color]="getPrimaryColor()"
                    [style.color]="getHeadingColor()"
                    (click)="onBookAppointment(package)">Book Appointment</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading detailing packages...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-state">
    <p>{{ error }}</p>
  </div>

  <!-- No Packages State -->
  <div *ngIf="!loading && !error && packages.length === 0" class="no-packages-state">
    <p>No detailing packages available at the moment.</p>
  </div>

  <!-- Footer -->
  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-champs-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [deviceType]="deviceType"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-champs-page-footer>
  </div>

  <!-- Book Appointment Modal -->
  <app-shared-book-appointment-modal
    [isVisible]="showBookAppointmentModal"
    [serviceOptions]="getServiceOptions()"
    [isSubmitting]="isSubmittingAppointment"
    [errorMessage]="appointmentError"
    (close)="onCloseModal()"
    (schedule)="onScheduleAppointment($event)">
  </app-shared-book-appointment-modal>

  <!-- Success Modal -->
  <app-success-modal
    [isVisible]="showSuccessModal"
    [data]="successModalData"
    (close)="onCloseSuccessModal()">
  </app-success-modal>
</div>

